import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

/**
 * "מסונן מדף הבית: ‹label› ✕" (PRD §6.1 #3, F-003): shown on a list opened
 * from a Home "ממתין לך" chip, so the user sees why the list holds exactly the
 * number they clicked. ✕ clears that filter and returns the list to normal.
 */
export function HomeFilterChip({ label, onClear, className = '' }: { label: string; onClear: () => void; className?: string }) {
  const { t } = useTranslation();
  return (
    <div className={`inline-flex max-w-full items-center gap-1 rounded-full bg-accent-soft ps-3 pe-1 text-sm text-accent-soft-text ${className}`}>
      <span className="truncate py-1">{t('home.filtered.label', { label })}</span>
      <button
        type="button"
        onClick={onClear}
        className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full hover:bg-primary-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus touch-target"
        aria-label={t('home.filtered.clear', { label })}
      >
        <X size={14} aria-hidden />
      </button>
    </div>
  );
}
